<template>
<div v-if="amazingOffers != null && amazingOffers.length > 0" class="specials-product-swiper" style="background-color: #1399b6;">
	<section class="specials-product-swiper-container dcfcfc-fd">
        <a href="/" class="specials-product-swiper-title">
            <img src="../../../public/assets/img/amazing/Product-Slider-image.png" />
        </a>
	    <div class="widget widget-product card" v-if="amazingOffers != '' && amazingOffers != null">
        <div id="" class="product-amazing   owl-carousel owl-theme">
            <div style="position:relative" class="item  discount-box" v-for="(product,index) in amazingOffers">
                <span class="discount" v-if="product.DiscountPercent != 0  && product.Price != 0 && product.IsAvailable">{{product.DiscountPercent}} %</span>

                <div :class="!product.IsAvailable ? 'filter' : '' ">
                    <router-link :title="product.ProductName" :to="product.TitleUrl != null  ? { name: 'product' , params: { productId: product.ProductId , productName: product.TitleUrl.replace(/\//g, '-').replace(/\*/g, '-').replace(/\s+/g, '-') }} : { name: 'product' , params: { productId: product.ProductId , productName: product.ProductName.replace(/\//g, '-').replace(/\*/g, '-').replace(/\s+/g, '-') }}">
                        <img :src="product.PicPath" class="img-fluid" :alt="product.AltPicPath" :title="product.ProductName.replace(/\s+/g, '-')" @error="imageLoadOnError">
                    </router-link>
                    <h2 class="post-title">
                        <router-link tag="a" :title="product.ProductName" :to="product.TitleUrl != null  ? { name: 'product' , params: { productId: product.ProductId , productName: product.TitleUrl.replace(/\//g, '-').replace(/\*/g, '-').replace(/\s+/g, '-') }} : { name: 'product' , params: { productId: product.ProductId , productName: product.ProductName.replace(/\//g, '-').replace(/\*/g, '-').replace(/\s+/g, '-') }}">{{ product.ProductName }}</router-link>
                    </h2>
                    <div class="price" v-if="product.Price != 0">
                        <div class="flex-price" v-if="product.IsAvailable">
                            <div class="text-center" v-if="product.DiscountPercent != 0">
                                <del><span>{{ product.Price | formatNumber }}<span> تومان </span></span></del>
                            </div>
                            <div class="text-center">
                                <ins><span>{{ product.FinalPrice | formatNumber }}<span> تومان </span></span></ins>
                            </div>
                        </div>
                        <div v-else>
                            <span class="unAvailable">استعلام قیمت</span>
                        </div>
                        <!-- استعلام قیمت -->
                    </div>
                    <div v-if="product.Price == 0">
                        <div class="callToMain">
                            <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
	</section>
</div>
</template>

<script>
    export default {
        computed: {
             amazingOffers: function () {
                return this.$store.getters.readAmazingOffers;
            }
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
        }
    }
</script>

<style scoped>
    .discount {
        position: absolute;
        padding: 4px 6px 1px;
        left:10px;
        background-color: #fb3449;
        color: #fff;
        border-radius: 20px;
        letter-spacing: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
    }
    .widget, .brand-slider {
        background: unset;
        padding: 1px;
    }
    .card {
        box-shadow: unset;
    }
    .widget-product .product-amazing .owl-item {
        border: unset;
    }
    .widget-product .product-amazing .item,
    .widget-product .product-carousel .item,
    .brand-slider .owl-carousel .item {
      
    }
    .specials-product-swiper {
        margin-bottom:15px;
    }
  /*  .specials-product-swiper-title img {
        width: 100%;
        max-height: calc(100% - 41px);
        -o-object-fit: contain;
        object-fit: contain;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }*/
 
    .specials-product-swiper a {
        box-shadow: none !important;
    }

    .specials-product-swiper-title {
        margin: 0 44px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        width: 170px;
    }



    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .unAvailable::after {
            top: 13px;
            left: 0px;
        }
        .discount {
            position: absolute;
            padding: 4px 6px 1px;
            left: 10px;
            bottom: 110px;
            font-size: 14px;
        }
        .specials-product-swiper-title[data-v-b7c23bc6] {
            margin: 0 10px;
        }
            .unAvailable::before {
            top: 13px;
            right: 0;
        }
        .unAvailable {
            font-size: 13px;
        }
    }


</style>